import { hasCapability } from '../../shell/feature-flags/businessCapabilitiesService';
import {
  getStockSalePolicyForBranch,
  type StockSalePolicy,
} from '../../shell/session/settingsRepo';
import { useBusinessProfileStore } from '../../shell/session/store/useBusinessProfileStore';

/** Política de venta sin stock cuando la capability `inventory` está apagada (modo caja). */
export function resolveEffectiveStockSalePolicy(
  branchPolicy: StockSalePolicy,
  inventoryCapabilityEnabled: boolean,
): StockSalePolicy {
  return inventoryCapabilityEnabled ? branchPolicy : 'allow';
}

/** Política efectiva para cobro y avisos: sucursal × «Llevás stock» (inventory). */
export function getEffectiveStockSalePolicy(branchId: string | null | undefined): StockSalePolicy {
  const branchPolicy = getStockSalePolicyForBranch(branchId);
  const profile = useBusinessProfileStore.getState().profile;
  const inventoryEnabled = hasCapability(profile, 'inventory');
  return resolveEffectiveStockSalePolicy(branchPolicy, inventoryEnabled);
}
